module.exports = __webpack_public_path__ + "static/media/primary-banner-login.a6822901.png";